import { useTranslation } from "react-i18next";
import { Button, Checkbox, HStack, SimpleGrid, VStack } from "@chakra-ui/react";

const CheckboxGroupField = ({ options = [], value = [], onChange }) => {
  const { t } = useTranslation();

  const toggle = (v) =>
    onChange(value.includes(v) ? value.filter((x) => x !== v) : [...value, v]);

  return (
    <VStack align="stretch" spacing={3}>
      <HStack spacing={3}>
        <Button
          type="button"
          size="xs"
          bg="green.500"
          color="white"
          textTransform="capitalize"
          _hover={{ opacity: 0.9 }}
          onClick={() => onChange(options.map((o) => o.value))}
        >
          {t("general.select_all")}
        </Button>
        <Button
          type="button"
          size="xs"
          variant="outline"
          textTransform="capitalize"
          onClick={() => onChange([])}
        >
          {t("general.clear_all")}
        </Button>
      </HStack>

      <SimpleGrid
        columns={{ base: 1, sm: 2, md: 3 }}
        spacing={3}
        border="1px solid #DDD"
        borderRadius={4}
        p={3}
        maxH="260px"
        overflowY="auto"
      >
        {options.map((o) => (
          <Checkbox
            key={o.value}
            size="sm"
            isChecked={value.includes(o.value)}
            onChange={() => toggle(o.value)}
          >
            {o.label}
          </Checkbox>
        ))}
      </SimpleGrid>
    </VStack>
  );
};

export default CheckboxGroupField;